export class NestedLinksModule {
        constructor() {
            this.nestedLinks = document.querySelectorAll('[role="link"]');
            this.init();
        }

        init() {
            if(this.nestedLinks.length > 0){
                this.buildLink();
            }

        }

        buildLink() {

        Array.from(this.nestedLinks).forEach(function(nestedLink) {
            nestedLink.addEventListener('click', function(e) {
                if (typeof this.dataset.url != 'undefined') {
                    var url = this.dataset.url;
                    url && (e.preventDefault(),
                            e.stopPropagation(),
                            window.open && e.metaKey ? window.open(url) : window.location.assign(url)
                    );
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/sleeping-giants/assets/scripts/src/App/NestedLinksModule.js